export default __webpack_public_path__ + "static/media/manasa.9a89dd89.png";